import useCurrentRole from 'containers/User/useCurrentRole.js';
import sameRole from 'utils/sameRole.js';

function useIsOwn() {
  const role = useCurrentRole();
  return (otherRole) => sameRole(role, otherRole);
}

export default useIsOwn;
